import { useState } from 'react';
import { Button, message } from 'antd';
import classnames from 'classnames/bind';

import type { RecommendFormData } from '@portalCommon/type';
import { RecommendShareModal, RecommendFormModal } from '..';
import styles from './index.module.less';

const cx = classnames.bind(styles);

export function RecommendBtn(props: { className?: string }) {
  const [formOpen, setFormOpen] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const [messageApi, messageContextHolder] = message.useMessage();

  const onClick = () => {
    setFormOpen(true);
  };
  const onClose = (value?: RecommendFormData) => {
    setFormOpen(false);
    // value 存在为提交成功 => 打开推荐分享弹框
    if (value) {
      messageApi.success('信息提交成功', 1);
      setShareOpen(true);
    }
  };
  return (
    <>
      <Button id={cx('recommend-btn')} onClick={onClick} className={cx(props.className)}>
        立即推荐
      </Button>
      {messageContextHolder}
      {formOpen && <RecommendFormModal onClose={onClose} />}
      {shareOpen && <RecommendShareModal onClose={setShareOpen.bind(null, false)} width={1047} />}
    </>
  );
}
